import { Client, EService } from "generated/graphql";


export const useCards = (text: any, client: Client) => [
  {
    image: "group.svg",
    title: text.all.mailing,
    description: text.homePage.easy_colis_text,
    button: text.all.send_parcels,
    url: "parcels/creations",
    disabled: !client?.services?.includes(EService.Msg),
  },
  {
    image: "group-2.svg",
    title: text.all.dedicated_courier,
    description: text.homePage.sama_papser_text,
    button: text.all.request_quote,
    url: "tracking/request/samapapser",
    disabled: process.env.REACT_APP_SAMA_PAPSER_DISABLED_CHECK === "true" || !client?.services?.includes(EService.Mad),
  },
  {
    image: "group-4.svg",
    title: text.homePage.paps_tour_title,
    description: text.homePage.paps_tour_text,
    button: text.all.request_quote,
    url: "tracking/request/tour",
    disabled: process.env.REACT_APP_PAPS_TOUR_DISABLED_CHECK === "true" || !client?.services?.includes(EService.Tr),
  },
  {
    image: "group-3.svg",
    title: text.homePage.national_transport_title,
    description: text.homePage.national_transport_text,
    button: text.all.request_quote,
    url: "national-transport",
    disabled: process.env.REACT_APP_TRANSPORT_NATIONAL_DISABLED_CHECK === "true" || !client?.services?.includes(EService.Nt),
  },

  {
    image: "group-5.svg",
    title: text.homePage.course_title,
    description: text.homePage.course_text,
    button: text.course.new_course,
    url: "course/creation",
    disabled: process.env.REACT_APP_COURSE_DISABLED_CHECK === "true" || !client?.services?.includes(EService.Course),
  },
];
